import React, { Fragment }  from 'react';
import PropTypes from 'prop-types';
import SlideshowLander from './SlideshowLander';
import ArticleSlide from './ArticleSlide';
import ArticleSlides from './ArticleSlides';
import Ad from '../../../Ad';
import './article-slideshow.scss';
import { APP_ENV } from '../../../../consts';
import { segmentTrackEvent, isValid, isText, decodeTags } from '../../../../utils';



class ArticleSlideshow extends React.Component {
  constructor(props) {
    super(props);
  }

  handleLinkClick(e) {
    const { target } = e;
    const targetTagName = target.tagName.toLowerCase();
    let trackableElement = target;
    let innerHTML = '';
    if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
      if (targetTagName === 'img') {
        trackableElement = target.parentNode;
        innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
      } else {
        ({ innerHTML } = target);
      }
    }
    const destinationUrl = trackableElement.getAttribute('href');
    const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
    const articleClickedTracker = {
      destinationUrl,
      module: 'slideshow',
      category: 'incontent',
      action: 'click',
      linkType,
      articleType: this.props.sponsorship.articleType,
      label: `${innerHTML} hyperlink`,
    };
    segmentTrackEvent('article_clicked', articleClickedTracker);
  };

    // if text includes relatedTag, save the body text, related story link, and any text that comes after the related link, into their own variables to render:
  handleRelatedStory(text) {
    const strongTag = "<strong>RELATED</strong>: ";

    // find index where relatedTag begins
    let relatedStartIndex = text.indexOf('<p class="related-story-link">');
    // save the related tag and its contents in a variable
    let relatedLinkBodyText = text.slice(relatedStartIndex);
    // find the index where the closing p tag of the related story link ends
    let relatedEndIndex = relatedLinkBodyText.indexOf("</p>");
    relatedEndIndex += 4; // so that it includes up to the closing '>' of '</p>'
    // save the body text that was getting included within the related link container into its own variable
    let bodyTextAfterRelatedLink = relatedLinkBodyText.slice(relatedEndIndex);
    relatedLinkBodyText = relatedLinkBodyText.substring(0, relatedEndIndex);
    if (relatedLinkBodyText.includes("&nbsp;")) {
      relatedLinkBodyText = relatedLinkBodyText.replace(/&nbsp;/g, " ");
    }
    if (relatedLinkBodyText.includes(strongTag)) {
      relatedLinkBodyText = relatedLinkBodyText.replace(strongTag, "");
    }
    const included = relatedLinkBodyText.toLowerCase().includes("related: ");
    if (included) {
      relatedLinkBodyText = relatedLinkBodyText
        .toLowerCase()
        .replace("related: ", "");
    }
    // save the bodyText minus relatedLinkBodyText text in a new variable
    let justBodyText = text.slice(0, relatedStartIndex);
    return {
      relatedLinkBodyText,
      bodyTextAfterRelatedLink,
      justBodyText,
    };
  }

  render () {
    const {
      id,
      headline,
      data,
      isMobile,
      fullUrl=null,
      isClient,
      hasAds,
      adType,
      category,
      pubData,
      name,
      authorImg,
      link,
      sponsorship,
      display,
      tags,
      secondAuthorName,
      secondAuthorText,
      secondAuthorUrl,
      isAffiliate,
      articleLayout,
      seo
     } = this.props;
     if (!isValid(data)) { return null; }
    const { hed=null, lander, slides=[] } = data;
    const adUnit = `purewow/${category}/article`;
    const isSponsored = sponsorship.articleType === 'Sponsored';
   
    let renderedSlides = slides.map((slide, i) => (
        <ArticleSlide
          key={i}
          data={slide}
          currentSlide={i}
          totalNum={slides.length}
          fullUrl={fullUrl}
          isClient={isClient}
          isMobile={isMobile}
          hasAds={hasAds}
          adUnit={adUnit}
          id={id} 
          sponsorship={sponsorship}
          articleLayout={articleLayout}
          handleLinkClick={this.handleLinkClick}
          handleRelatedStory={this.handleRelatedStory}
          seo={seo} />
    ));

    // For mobile slideshow list, insert ads following article logic with lander being module 1
    if (isMobile && hasAds) {
        const numOfSlides = renderedSlides.length;
        let slotName = "purewow_incontent"
        let adCount = 1;
        let teadsAdCount = 1;
        let increment = (numOfSlides >= 15) ? 5 : 4;
        let index = 0;
        let adInsertIndex = 0;
        let teadsInsertIndex = 2;
        let teadsName = "purewow_teads";
        if (!(renderedSlides.some(slide => slide.type === 'ad'))) {
          // Ads will appear after every 3 or 4 modules
          while (index <= renderedSlides.length) {
            slotName = adCount == 1 ? "purewow_incontent_top" : "purewow_incontent";
            // Insert intersitial ads at index points, no ad after last slide
            if ( index == adInsertIndex && adInsertIndex != renderedSlides.length){
              renderedSlides.splice((adInsertIndex), 0,
                <Ad data={{ adUnit: adUnit, slotName: slotName }}/>
              );
              adInsertIndex += increment;
              adCount += 1;
            }
            // Insert Teads ad after 1st and 7th slides
            if (index == teadsInsertIndex && teadsInsertIndex != renderedSlides.length && teadsAdCount <= 2 ){
              teadsName = teadsAdCount == 1 ? "purewow_teads" : `purewow_teads_2`;
              renderedSlides.splice((teadsInsertIndex), 0,                
                <Ad data={{ adUnit: adUnit, slotName: "purewow_teads", teadsName: teadsName }}/>
              );
              adInsertIndex += 1;
              teadsAdCount += 1;
              teadsInsertIndex += ((numOfSlides >= 15) ? 8 : 9);
            }
            index += 1;
          }
        }
    }

    return (
      <div className="article-slideshow">
        { isMobile ? (
          <Fragment>
            <SlideshowLander
              data={lander}
              isMobile={isMobile}
              sponsorship={sponsorship}
              pubData={pubData}
              display={display}
              tags={tags}
              fullUrl={fullUrl} 
              handleLinkClick={this.handleLinkClick}
              handleRelatedStory={this.handleRelatedStory}
              seo={seo}
              isSponsored={isSponsored} />
            {renderedSlides}
          </Fragment>
        ) : (
          <ArticleSlides 
            slides={slides} 
            fullUrl={fullUrl}
            isClient={isClient}
            isMobile={isMobile}
            hasAds={hasAds}
            adUnit={adUnit}
            id={id}
            headline={headline}
            sponsorship={sponsorship}
            articleLayout={articleLayout} 
            data={data}
            category={category}
            pubData={pubData}
            name={name}
            authorImg={authorImg}
            link={link}
            display={display}
            tags={tags}
            secondAuthorName={secondAuthorName}
            secondAuthorText={secondAuthorText}
            secondAuthorUrl={secondAuthorUrl}
            isAffiliate={isAffiliate} 
            isSponsored={isSponsored} 
            handleLinkClick={this.handleLinkClick} 
            handleRelatedStory={this.handleRelatedStory}
            seo={seo} />
        )}
      </div>
    );
  }
};


ArticleSlideshow.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default ArticleSlideshow;
